import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from 'src/styles/button.style';
import { PanelSectionContent, PanelSubHeader } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import CargoNumber from '../../../common/cargoNumber';
import { CargoOverviewContent, CargoOverviewDetails, CargoDetailItem, CargoDetailLabel, CargoDetailValue } from './OperationsForCargoPanel.styles';
import { RotationCargoOperationVM } from 'src/utils/stowage/stowageOperation/operationFormatUtils';

interface CargoOverviewSectionProps {
    cargoOperationsList: RotationCargoOperationVM[];
    isExpanded: boolean;
    onToggle: () => void;
    tradeName: string;
    optionDetails: string;
}

const CargoOverviewSection: React.FC<CargoOverviewSectionProps> = ({ cargoOperationsList, isExpanded, onToggle, tradeName, optionDetails }) => {
    const cargo = cargoOperationsList[0]?.cargo;
    const loadingPorts = cargo?.loadingPortNames?.map((port) => port.name).join(', ') || 'N/A';
    const unloadingPorts = cargo?.unloadingPortNames?.map((port) => port.name).join(', ') || 'N/A';

    return (
        <PanelSectionContent>
            <PanelSubHeader>
                <CargoNumber withPadding includeColoredBackground cargo={cargo} />
                {tradeName}
                <IconButton className="grey-button" onClick={onToggle}>
                    <FontAwesomeIcon icon={isExpanded ? 'chevron-circle-up' : 'chevron-circle-down'} />
                </IconButton>
            </PanelSubHeader>
            <CargoOverviewContent isExpanded={isExpanded}>
                <CargoOverviewDetails>
                    <CargoDetailItem>
                        <CargoDetailLabel>Product Name:</CargoDetailLabel>
                        <CargoDetailValue>{tradeName}</CargoDetailValue>
                    </CargoDetailItem>
                    <CargoDetailItem>
                        <CargoDetailLabel>Option Details:</CargoDetailLabel>
                        <CargoDetailValue>{optionDetails}</CargoDetailValue>
                    </CargoDetailItem>
                    <CargoDetailItem>
                        <CargoDetailLabel>Loading Ports:</CargoDetailLabel>
                        <CargoDetailValue>{loadingPorts}</CargoDetailValue>
                    </CargoDetailItem>
                    <CargoDetailItem>
                        <CargoDetailLabel>Unloading Ports:</CargoDetailLabel>
                        <CargoDetailValue>{unloadingPorts}</CargoDetailValue>
                    </CargoDetailItem>
                </CargoOverviewDetails>
            </CargoOverviewContent>
        </PanelSectionContent>
    );
};

export default CargoOverviewSection;
